import request from '@src/utils/request'
import { handleCommonError } from '@src/utils/request/errorHandle'

/**
 * 直接下载
 */

export function downloadByUrl(url: string, filename: string) {
	request({
		url: url,
		method: 'get',
		responseType: 'blob',
		download: true //oss 下载请求不携带 cors 请求头 以及 不用拼接 url进行转发
	}).then(async (res) => {
		// 创建一个 Blob 对象，类型为 Excel 文件
		const status = res.data.code
		if (status == 500) {
			const { data, config } = res
			const jsonStr = await data.text()
			handleCommonError(JSON.parse(jsonStr), config) //异常弹窗
			return
		}
		const blob = new Blob([res.data])
		// 创建一个 <a> 标签用于下载
		const downloadUrl = window.URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = downloadUrl
		a.download = filename // 设置下载文件名
		document.body.appendChild(a)
		a.click()
		// 清理对象 URL
		window.URL.revokeObjectURL(downloadUrl)
		document.body.removeChild(a)
	})
}
/**
 * 从服务器下载文件的方式
 * 非 OSS 使用
 * @param url
 * @param filename
 */
export function downloadByUrlFromServer(url: string, filename: string) {
	request({
		url: url,
		method: 'get',
		responseType: 'blob'
	}).then((res) => {
		// 创建一个 Blob 对象，类型为 Excel 文件
		const blob = new Blob([res.data])
		// 创建一个 <a> 标签用于下载
		const downloadUrl = window.URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = downloadUrl
		a.download = filename // 设置下载文件名
		document.body.appendChild(a)
		a.click()
		// 清理对象 URL
		window.URL.revokeObjectURL(downloadUrl)
		document.body.removeChild(a)
	})
}

/**
 * 从已获取到的 Blob 对象触发浏览器下载
 * 适用于：后端接口直接返回二进制流（如 export 接口），调用方自行 fetch 拿到 Blob
 * 与 downloadByUrl* 行为一致，但不消耗 URL，便于处理鉴权/跨域场景
 * @param blob 二进制数据
 * @param filename 下载时的文件名
 */
export function downloadBlob(blob: Blob, filename: string) {
	const url = window.URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = url
	a.download = filename
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a)
	window.URL.revokeObjectURL(url)
}

/**
 * 通用 mock 导出工具：当前端没有真实 export 接口时，生成一个 CSV Blob
 * 让 OneTable 的「导出」按钮可以端到端跑通；后端 export 接口就绪后，
 * 直接把调用方替换为：
 *   return fetcher('/xxx/export', 'POST', { body, responseType: 'blob' })
 *
 * 约定入参与 OneTable 透传一致：{ dto, pageNum, pageSize }
 *  - header: CSV 表头
 *  - rows:   数据行（每行数组，元素顺序需与 header 一致；调用方自行处理转义/格式化）
 *  - meta:   可选的额外注释行（如来源模块等）
 */
export async function mockCsvExport(
	body: { dto: any; pageNum: number; pageSize: number },
	options: {
		header: string[]
		rows: (string | number | null | undefined)[][]
		meta?: string[]
	}
): Promise<Blob> {
	// 模拟后端耗时，便于看到 loading 提示
	await new Promise((r) => setTimeout(r, 600))
	const lines: string[] = [
		`# 导出时间: ${new Date().toISOString()}`,
		`# 查询条件 (dto): ${JSON.stringify(body?.dto ?? {})}`,
		`# pageNum: ${body?.pageNum}, pageSize: ${body?.pageSize}`,
		...(options.meta ?? []),
		options.header.join(',')
	]
	for (const row of options.rows) {
		lines.push(row.map((v) => (v == null ? '' : String(v))).join(','))
	}
	// 加 BOM 让 Excel 打开中文不乱码
	const csv = '\uFEFF' + lines.join('\n')
	return new Blob([csv], { type: 'text/csv;charset=utf-8;' })
}
